import { ProfibilityState } from 'store/ducks/state'

export function fetchCalculatorConfigs() {
  return {
    url: `/api/profitability_config`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}

export function updateCalculatorConfig(payload: ProfibilityState) {
  return {
    url: `/api/profitability_config`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
    body: JSON.stringify(payload),
  }
}
